import React from 'react'
import PropTypes from 'prop-types'

import Poolwerx from '../../images/brand_poolwerx.png'

const PreFooter = props => {
	return (
		<section className="PreFooter">
			<div className="container">
				<div className="columns">
					<div className="column is-one-third-desktop">
						<img src={Poolwerx} alt="Poolwerx" className="logo" />
					</div>
				</div>
			</div>
		</section>
	)
}

export default PreFooter
